import React, { useRef } from 'react';
import { price } from 'researcher/helpers/price';
import { PaymentForm } from 'researcher/payment';
import { T } from 'shared/helper/translate';
import Loading from 'researcher/components/Loading';
import InvoicePaymentSidebar from './InvoicePaymentSidebar';
var InvoicePayment = function InvoicePayment(_ref) {
  var creditBalance = _ref.creditBalance,
    currency = _ref.currency,
    displayCredits = _ref.displayCredits,
    excludedPaymentMethods = _ref.excludedPaymentMethods,
    formData = _ref.formData,
    payoffReceiptCodes = _ref.invoiceNumbers,
    paymentCurrencyMatchesInvoiceCurrency = _ref.paymentCurrencyMatchesInvoiceCurrency,
    receiptCode = _ref.receiptCode,
    status = _ref.status,
    total = _ref.total,
    unpaidInvoices = _ref.unpaidInvoices,
    usdTotal = _ref.usdTotal;
  var form = useRef(null);
  var submitForm = function submitForm() {
    return form.current.dispatchEvent(new Event('submit', {
      cancelable: true,
      bubbles: true
    }));
  };
  if (unpaidInvoices.length === 0) {
    return /*#__PURE__*/React.createElement(Loading, {
      text: "invoices-loading-message"
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-8 col-12"
  }, /*#__PURE__*/React.createElement(PaymentForm, {
    additionalData: {
      payoffReceiptCodes: payoffReceiptCodes
    },
    currency: currency,
    excludePaymentMethods: excludedPaymentMethods,
    fapiaoSelectionDisabled: unpaidInvoices.length !== 1,
    formRef: form,
    hideInvoiceAddress: true,
    paymentsEndpoint: "/api/payoff/payment",
    receiptCode: receiptCode,
    total: total
  }), displayCredits ? /*#__PURE__*/React.createElement("div", {
    className: "mt-4 alert alert-info"
  }, /*#__PURE__*/React.createElement(T, {
    inline: true,
    source: "You have %(bankCredits)s bank credits available.",
    params: {
      bankCredits: price(currency, creditBalance)
    }
  })) : null), /*#__PURE__*/React.createElement(InvoicePaymentSidebar, {
    currency: currency,
    formData: formData,
    paymentCurrencyMatchesInvoiceCurrency: paymentCurrencyMatchesInvoiceCurrency,
    status: status,
    submitForm: submitForm,
    total: total,
    unpaidInvoices: unpaidInvoices,
    usdTotal: usdTotal
  })));
};
export default InvoicePayment;